<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="8">
              <el-form-item label="设备IMEI号" prop="deviceSerial">
                
                <el-input
                  clearable
                  disabled
                   v-model="form.deviceSerial"
                  
                  maxlength="100"
                ></el-input> 
               
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="设备编号" prop="code">
                
                <el-input
                  clearable
                  disabled v-model="form.code"
                 
                  maxlength="100"
                ></el-input> 
               
              </el-form-item>
            </el-col>
  
            <el-col :span="8">
              <el-form-item label="设备名称" prop="name"> 
  
  
                <el-input
                  clearable
                  disabled
                   v-model="form.name"
                  
                  maxlength="20"
                ></el-input> 
                
              </el-form-item>
            </el-col>
          <el-col :span="24">
         <h4>维修信息</h4>
            <el-divider></el-divider>
          </el-col>
         
          <el-col :span="12">
            <el-form-item label="报修时间" prop="reportTime">
              <el-date-picker
                v-model="form.reportTime"
                style="width: 100%;"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择报修时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维修人员" prop="repairUserName">
              <el-input clearable  placeholder="请输入维修人员"  v-model="form.repairUserName" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="故障类型" prop="troubleType">
              <el-input clearable   placeholder="请输入故障类型"  v-model="form.troubleType" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="故障原因" prop="troubleReason">
              <el-input clearable  type="textarea"
              placeholder="请输入故障原因"
                :rows="2" v-model="form.troubleReason" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维修开始时间" prop="repairStartTime">
                <el-date-picker
                v-model="form.repairStartTime"
                style="width: 100%;"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择报修开始时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维修结束时间" prop="repairEndTime">
                <el-date-picker
                v-model="form.repairEndTime"
                style="width: 100%;"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择报修结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维修费用" prop="repairAmount">
                <money-input
                 v-model="form.repairAmount"
                templateName="元"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
         
          <el-col :span="24">
            <el-form-item label="维修说明" prop="description">
              <el-input
              maxlength="500"
                type="textarea"
                :rows="2"
                placeholder="请输入维修说明"
                v-model="form.description"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
<script>

import { smartDeviceResumeRepairSave } from '@/api/nursingHome/elderDevice';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
  
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      provideList: [],
      form: {
        deviceSerial:"",
        code: '',
        name: '',
        reportTime: '',
        repairUserName: '',
        troubleType: '',
        troubleReason: '',
        repairEndTime: '',
        repairAmount: '',
        description: '',
      },
      formRules: {
       
        reportTime:[{ required: true, message: '报修时间不能为空', trigger: 'change' }],
        repairUserName: [{ required: true, message: '维修人员不能为空', trigger: 'blur' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      
      paymentTypeList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    
    async initData() {
      this.form.deviceSerial = this.row.deviceSerial
      this.form.code = this.row.code
      this.form.name = this.row.name
      this.form.deviceId = this.row.id
    },
    saveRecord() {
      if(this.form.repairEndTime!=""&&this.form.repairStartTime!=""){
        if(this.form.repairEndTime<this.form.repairStartTime){
          this.$message.error("维修结束时间不能小于维修开始时间")
          return
        }
      }
      this.$refs['formRef'].validate((valid) => {
          if (valid) {
            smartDeviceResumeRepairSave(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }
        });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
